module.exports = __webpack_public_path__ + "img/setup_low_stock.55dad4cd.svg";